<template>
  <view-container>
    <v-card>
      <v-card-text>
        <v-form v-model="valid">
          <reference-field
            v-if="!user.clientId"
            v-model="itemGroup.clientId"
            :rules="rules.clientId"
            :disabled="!!itemGroup.clientId"
            reference="client"
            label="Клиент"
          />
          <v-text-field
            v-model="itemGroup.name"
            :rules="rules.name"
            label="Название"
          />
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn @click="save" :disabled="!valid">{{
          itemGroup.id ? "Сохранить" : "Создать"
        }}</v-btn>
        <v-btn text @click="cancel">Отмена</v-btn>
        <v-spacer />
        <confirmation-dialog
          v-if="itemGroup.id"
          @confirm="onDelete"
          title="Удалить безвозвратно?"
          text="Удаление группы товарной позиции не повлияет на входящие в неё позиции."
          color="red"
        >
          <template #activator="{ on }">
            <v-btn color="red" text dark v-on="on">Удалить</v-btn>
          </template>
        </confirmation-dialog>
      </v-card-actions>
    </v-card>
  </view-container>
</template>
<script>
import ds from "@/datastore";
import { TaxTypes, ProductTypes } from "@/datastore/enums";
export default {
  name: "ItemGroupEdit",
  props: {
    id: String,
    clientId: String
  },
  data() {
    return {
      dialog: false,
      itemGroup: ds.createRecord(
        "itemGroup",
        {
          clientId: this.clientId
        },
        { noValidate: true }
      ),
      taxTypes: TaxTypes,
      productTypes: ProductTypes,
      valid: false
    };
  },
  async created() {
    if (this.id) {
      let itemGroup = await ds.find("itemGroup", this.id);
      this.itemGroup = ds.createRecord("itemGroup", itemGroup.toJSON(), {
        noValidate: true
      });
      this.$store.commit("setTitle", "Группа позиций " + this.itemGroup.name);
    } else if (this.user.clientId) {
      this.itemGroup.clientId = this.user.clientId;
    }
  },
  computed: {
    user() {
      return this.$store.getters["auth/getUser"];
    },
    rules() {
      return this.itemGroup.$rules || {};
    }
  },
  methods: {
    async save() {
      let itemGroup = await this.itemGroup.save();
      this.$store.commit("notifications/success", "Группа позиций сохранена");
      this.cancel();
      return itemGroup;
    },
    async onDelete() {
      await this.itemGroup.destroy();
      this.$store.commit("notifications/success", "Группа позиций удалена");
      this.cancel();
    },
    cancel() {
      this.$destroy();
      this.$router.go(-1);
    }
  }
};
</script>
